<template>
    <app-framework>
        <template v-slot:title>
            <tw-divider color="white"
                        width="56"
                        class="mb-3"
            ></tw-divider>
            Advisory Service
        </template>
        <row>
            <column class="text-secondary" cols="full">
                <row class="mb-10">
                    <column class="xs:text-center sm:text-center md:text-right xs:items-center sm:items-center md:items-end"
                            cols="full"
                    >
                        <tw-divider class="mb-5" color="primary" width="56"></tw-divider>
                        <div class="poppins-bold tracking-normal xs:text-3xl sm:text-5xl leading-tight mt-5">
                            Advisory Service
                        </div>
                        <div class="text-xl tracking-normal leading-snug xs:w-full sm:w-full md:w-4/5 lg:w-3/5 xl:1/2 my-16">
                            Our services focus on our client’s performance inhibitors, strengths and opportunities.
                            We follow a phased approach in the development and implementation of tailored solutions
                            aimed at the individual, team and/ or organisational level. All solutions are supported
                            by integrated change management and effective programme delivery.
                        </div>
                    </column>
                    <column cols="full">
                        <row align="stretch" justify="center">
                            <column :key="index"
                                    align="center"
                                    class="justify-center z-10 p-4"
                                    v-for="({fields, sys}, index) in $route.params.advisories"
                            >
                                <card class="flex flex-col text-secondary h-full relative"
                                      no-padding
                                      style="min-width: 300px; max-width: 300px; min-height: 450px; max-height: 450px;"
                                      :style="{minHeight: !!fields.coverImage ? '450px' : '250px', maxHeight: !!fields.coverImage ? '450px' : '100%'}"
                                >
                                    <img :class="fields.coverImage.fields ? 'contain' : 'center'"
                                         :src="fields.coverImage.fields ? fields.coverImage.fields.file.url : fields.logo.fields.file.url"
                                         alt=""
                                         class="round-top"
                                         v-if="!!fields.coverImage"
                                    >
                                    <div class="px-6 pb-6">
                                        <tw-divider class="mt-8 mb-6" color="primary" width="56"></tw-divider>
                                        <div class="uppercase w-full poppins-bold tracking-wide overflow-hidden leading-tight mb-5 ellipse-on-three"
                                        >{{ fields.name }}
                                        </div>
                                        <div class="tracking-normal leading-tight mb-5 overflow-hidden ellipse-on-three"
                                        >{{ fields.shortDescription }}
                                        </div>
                                        <div class="absolute" style="bottom: 20px;">
                                            <router-link
                                                    :to="{name: 'Advisory', params: {advisoryId: sys.id}}"
                                                    append
                                                    class="uppercase poppins-bold tracking-wide leading-tight text-primary"
                                            >Read More
                                            </router-link>
                                        </div>
                                    </div>
                                </card>
                            </column>
                        </row>
                    </column>
                </row>
            </column>
        </row>
    </app-framework>
</template>

<script>
    export default {
        name: "Advisories",
        components: {
            'app-framework': () => import('@/components/layout/AppFramework.vue'),
            'tw-divider': () => import('@/components/Divider.vue'),
            'card': () => import('@/components/Card.vue'),
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>